package com.xtream.data_kmp.dto



import androidx.room3.Embedded
import androidx.room3.Entity
import androidx.room3.Index
import com.xtream.data_kmp.AppConfig
import com.xtream.data_kmp.XtreamUtils

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


abstract class BaseAccount {
    @SerialName("user_info")
   abstract val userInfo: UserInfo?
    @SerialName("server_info")
   abstract val serverInfo: ServerInfo?


    abstract val isLoggedIn: Boolean?
}

const val usersTable="usersTable"
@Serializable()

@Entity(usersTable,primaryKeys = ["username"],indices = [Index(value = ["username","password"], unique = true)])
data class Account(



    @SerialName("user_info")
    @Embedded
    override val userInfo: UserInfo,
    @SerialName("server_info")
    @Embedded
    override val serverInfo: ServerInfo,
    override var isLoggedIn: Boolean=false

): BaseAccount(){
     fun getUserServerUrl():String{
        return XtreamUtils.buildBaseUrl(serverInfo)

    }
}

    @Serializable
    
data class ServerInfo(

        @SerialName("https_port")
        var httpsPort: String?=null,
        @SerialName("port")
        var port: String?=null,
        @SerialName("rtmp_port")
        var rtmpPort: String?=null,
        @SerialName("server_protocol")
        var serverProtocol: String?=null,
        @SerialName("time_now")
        var timeNow: String?=null,
        @SerialName("timestamp_now")
        var timestampNow: Int?=null,
        @SerialName("timezone")
        var timezone: String?=null,
        @SerialName("url")
        var url: String
    )

@Serializable()

data class UserInfo(
    @SerialName("active_cons")
        var activeCons: String?=null,
    @SerialName("allowed_output_formats")
        var allowedOutputFormats: List<String?>?=null,
    @SerialName("auth")
        var auth: Int?=null,

    @SerialName("created_at")
        var createdAt: String?=null,

    @SerialName("exp_date")
        var expDate: String?=null,

    @SerialName("is_trial")
        var isTrial: String?=null,

    @SerialName("max_connections")
        var maxConnections: String?=null,

    @SerialName("message")
        var message: String?=null,

    @SerialName("password")
        var password: String,

    @SerialName("status")
        var status: String?=null,

    @SerialName("username")
        var username: String,
    var token: String?=null,
    @SerialName("user_agent")
        var userAgent: String?= AppConfig.USER_AGENT,

    var activationCode: String?=null

    )


